import api from './api';

export const newsletterService = {
  // Subscribe to newsletter
  subscribe: (email) => api.post('/newsletter/subscribe', { email }),
  
  // Unsubscribe from newsletter
  unsubscribe: (email) => api.post('/newsletter/unsubscribe', { email }),

  // Admin functions
  getAllSubscribers: (params) => api.get('/newsletter/admin/subscribers', { params }),
  getNewsletterStats: () => api.get('/newsletter/admin/stats'),
  deleteSubscriber: (id) => api.delete(`/newsletter/admin/subscriber/${id}`),
};
